// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__2u_uR","dragIcon":"SortableItem_dragIcon__3X6La","disabled":"SortableItem_disabled__-ZGld"};